import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';

import { list } from '../../../api/common';

const loadingSearchPhonecallsToggle = () => ({
  type: TYPES.loadingFormSearch,
});

export const searchPhonecalls = params => {
  return dispatch => {
    dispatch(loadingSearchPhonecallsToggle());
    list(params, 'telefonema.php')
      .then(response =>
        dispatch({
          type: TYPES.searchPhonecallSuccess,
          payload: response,
        })
      )
      .then(() => dispatch(loadingSearchPhonecallsToggle()))
      .catch(() => dispatch({ type: TYPES.searchError }))
  }
};

export const clearFieldsFormSearch = () => ({
  type: TYPES.clearFormSearchFields,
});

export const setDefaultPageRules = () => ({
  type: TYPES.setDefaultPage,
});

export const openFormSearchLayer = () => ({
  type: COMMON_TYPES.toggleLayer, payload: 'search'
});

export const hideLayer = () => ({
  type: COMMON_TYPES.toggleLayer, payload: null
});

export const goToNextPage = params => {
  const pageNumber = params.page + 1;

  return dispatch => {
    dispatch(searchPhonecalls({ ...params, page: pageNumber }));
    dispatch({
      type: TYPES.paginationFormSearch,
      payload: pageNumber
    })
  }
}

export const goToPrevPage = params => {
  const pageNumber = params.page - 1;

  return dispatch => {
    dispatch(searchPhonecalls({ ...params, page: pageNumber }));
    dispatch({
      type: TYPES.paginationFormSearch,
      payload: pageNumber
    })
  }
}
